<script lang="ts" setup>
import {
  CircleCheckIcon,
  InfoIcon,
  TriangleAlertIcon,
  OctagonXIcon,
  Loader2Icon,
  XIcon,
} from '@lucide/vue'
import type { ToasterProps } from 'vue-sonner'
import { Toaster as Sonner } from 'vue-sonner'
import { cn } from '@/lib/utils'

const props = defineProps<ToasterProps>()

const sonnerProps = computed(() => ({
  ...props,
  class: cn('toaster group', props.class),
  toastOptions: {
    ...props.toastOptions,
    classes: {
      toast: 'rounded-2xl border',
      error: '!bg-[#ffe5e5] !border-[#ffb3b3] !text-destructive',
      success: '!bg-brand-green-light !border-brand-green !text-brand-green',
      ...props.toastOptions?.classes,
    },
  },
}))
</script>

<template>
  <Sonner v-bind="sonnerProps">
    <template #success-icon>
      <CircleCheckIcon class="size-4" />
    </template>
    <template #info-icon>
      <InfoIcon class="size-4" />
    </template>
    <template #warning-icon>
      <TriangleAlertIcon class="size-4" />
    </template>
    <template #error-icon>
      <OctagonXIcon class="size-4" />
    </template>
    <template #loading-icon>
      <div>
        <Loader2Icon class="size-4 animate-spin" />
      </div>
    </template>
    <template #close-icon>
      <XIcon class="size-4" />
    </template>
  </Sonner>
</template>
